"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var product_search_form_1 = require("../product_search_form/product_search_form");
var react_tracking_1 = require("react-tracking");
var tracker_1 = require("@reverbdotcom/commons/dist/tracker");
var bind_1 = require("../../bind");
var ProductSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(ProductSuggestion, _super);
    function ProductSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            results: [],
            inputValue: '',
        };
        return _this;
    }
    ProductSuggestion.prototype.handleProductSelected = function (product) {
        this.props.onProductSelected(product);
        var eventData = { entityId: product.id };
        if (this.props.analyticsSource) {
            eventData.context = { source: this.props.analyticsSource };
        }
        this.props.tracking.trackEvent(eventData);
        // hide the search results
        this.setState({
            results: [],
            inputValue: '',
        });
    };
    ProductSuggestion.prototype.handleChange = function (e) {
        this.setState({ inputValue: e.target.value });
    };
    ProductSuggestion.prototype.render = function () {
        return (React.createElement(product_search_form_1.default, { productSelected: this.handleProductSelected, currentListingIds: this.props.currentListingIds, results: this.state.results, inputValue: this.state.inputValue, onChange: this.handleChange }));
    };
    tslib_1.__decorate([
        bind_1.default
    ], ProductSuggestion.prototype, "handleProductSelected", null);
    tslib_1.__decorate([
        bind_1.default
    ], ProductSuggestion.prototype, "handleChange", null);
    ProductSuggestion = tslib_1.__decorate([
        react_tracking_1.default({
            name: 'ProductSuggestion',
            eventType: tracker_1.INTERACTION,
            type: 'listing',
        })
    ], ProductSuggestion);
    return ProductSuggestion;
}(React.Component));
exports.default = ProductSuggestion;
//# sourceMappingURL=product_suggestion.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/messages/product_suggestion.js
// module id = Ak2x
// module chunks = 20 21